import formConfig from './formConfig';

// Mapping of field names to user-friendly labels
const fieldLabels = {
  applicantName: "Applicant Name",
  beneficiaryName: "Beneficiary Name",
  lcAmount: "LC Amount",
  lcCurrency: "LC Currency",
  lcType: "LC Type",
  incoterm: "Incoterm",
  countryOrigin: "Country of Origin",
  countryDestination: "Country of Destination",
  goodsDescription: "Goods Description",
  expiryDate: "Expiry Date",
  paymentTerms: "Payment Terms",
  tradeType: "Trade Type",
  commodityDescription: "Commodity Description",
  portLoading: "Port of Loading",
  portDischarge: "Port of Discharge",
  requiredDocuments: "Required Documents",
  lcTenor: "LC Tenor",
  lcOpeningBankDetails: "LC Opening Bank Details",
  hsCode: "HS Code",
  buyerNameCountry: "Buyer Name Country",
  sellerNameCountry: "Seller Name Country",
  shipmentDate: "Shipment Date",
  tradeValue: "Trade Value",
  advisingConfirmingBankRequired: "Advising/Confirming Bank Required",
  confirmationRequired: "Confirmation Required",
  partialShipmentAllowed: "Partial Shipment Allowed",
  transshipmentAllowed: "Transshipment Allowed",
  instrumentTerms: "Instrument Terms",
  issuanceCharges: "Issuance Charges",
  confirmationCharges: "Confirmation Charges",
  interestRateMargin: "Interest Rate Margin",
  tenorOffered: "Tenor Offered",
  advisingConfirmingBank: "Advising/Confirming Bank",
  additionalDocuments: "Additional Documents",
  specialConditions: "Special Conditions",
  proformaInvoiceFile: "Proforma Invoice File",
  tradeDocsFile: "Trade Documents File",
  kycDocsFile: "KYC Documents File",
  responseDeadline: "Response Deadline",
  preferredFinancingRateType: "Preferred Financing Rate Type",
  maximumAcceptableCharges: "Maximum Acceptable Charges",
  additionalComments: "Additional Comments",
  GuaranteeType: "Guarantee Type",
  GuaranteeAmount: "Guarantee Amount",
  GuaranteeValidityDate: "Guarantee Validity Date",
  ClaimExpiryDate: "Claim Expiry Date",
  ClaimProcessInstructions: "Claim Process Instructions",
  UnderlyingContractRef: "Underlying Contract Reference",
  CounterGuarantee: "Counter Guarantee"
};

// Check if a field is visible for the given instrument and formData
export const isFieldVisible = (field, instrument, formData) => {
  const config = formConfig[instrument] || { visibleFields: [], conditionalFields: {} };
  if (config.conditionalFields[field]) {
    return config.conditionalFields[field](formData) && config.visibleFields.includes(field);
  }
  return config.visibleFields.includes(field);
};

// Validate form data based on the instrument
export const validateForm = (formData, instrument) => {
  const errors = {};
  const config = formConfig[instrument] || { mandatoryFields: [] };
  const mandatoryFields = [...config.mandatoryFields];

  // Add conditional mandatory fields
//   if (config.conditionalFields.lcTenor && config.conditionalFields.lcTenor(formData)) {
//     mandatoryFields.push("lcTenor");
//   }

  mandatoryFields.forEach((field) => {
    if (!formData[field] || formData[field].toString().trim() === "") {
      errors[field] = `${fieldLabels[field] || field} is required`;
    }
  });

  // Validate requiredDocuments
  if (mandatoryFields.includes("requiredDocuments")) {
    const requiredDocuments = formData.requiredDocuments || {};
    const isAnyDocumentSelected = Object.values(requiredDocuments).some((value) => value);
    if (!isAnyDocumentSelected) {
      errors.requiredDocuments = "At least one document must be selected";
    }
  }

  // Additional validation for specific fields
  if (formData.lcAmount && isNaN(formData.lcAmount)) {
    errors.lcAmount = "LC Amount must be a valid number";
  }

  return errors;
};